import React, {useMemo} from 'react'
import _ from 'lodash'
import TabPanel from '../Tabs/TabPanel'
import Action from './Action'

const TabActionFields = ({data, actions, entity_object, ...root}) => {
  const {next_action_fields = []} = data

  const entity_object_id = entity_object?.id || data.entity_object_ids[0]

  const next_actions = useMemo(() => {
    let _next_actions = []
    if (!!next_action_fields) {
      _next_actions =
        next_action_fields.find(f => f.entity_object_id === entity_object_id)?.next_actions || []

      _next_actions = _next_actions.map(f => {
        const action = actions.data.find(a => a.id === f.action_id) || {}
        return {
          ...f,
          change_return_name: action.change_return_name,
          return_name: action.return_name,
          entity_id: action?.entity_id || null,
          name: action?.name || null,
        }
      })
    }
    return _next_actions
  }, [entity_object_id, next_action_fields, actions])

  return (
    <TabPanel {...root}>
      {next_actions.map((action, i) => (
        <Action key={i} action={action} />
      ))}
    </TabPanel>
  )
}

export default TabActionFields
